jQuery(document).ready(function () {
  let open_message = "Show more";
  let close_message = "Show less";

  if ($("#wpl_lang").length) {
    switch ($("#wpl_lang").val()) {
      case "en":
        open_message = "Show more";
        close_message = "Show less";
        break;

      case "fr":
        open_message = "Montre plus";
        close_message = "Montrer moins";
        break;

      default:
        open_message = "عرض المزيد";
        close_message = "عرض أقل";
        break;
    }
  }

  let author_desc = $(".author-heading .content-container .author-description");
  let cloned_author_desc = author_desc
    .clone()
    .addClass("show author-desc-clone")
    .css({
      position: "fixed",
      visibility: "hidden",
      left: "0",
      top: "0",
      "white-space": "nowrap",
    })
    .appendTo("body");

  let cloned_width = cloned_author_desc.outerWidth();
  let cloned_height = cloned_author_desc.outerHeight();

  cloned_author_desc.remove();

  if (
    Math.round(cloned_width) >= Math.round(author_desc.outerWidth() * 3) ||
    Math.round(cloned_height) >= 72
  ) {
    $(`<a class="toggle-author-desc show">${open_message}</a>`).insertAfter(
      ".author-heading .content-container .author-description"
    );
  }

  $(document).on("click", ".toggle-author-desc", function (e) {
    if ($(e.target).is(".toggle-author-desc")) {
      if ($(".toggle-author-desc").hasClass("show")) {
        $(".toggle-author-desc").html(close_message);
      } else {
        $(".toggle-author-desc").html(open_message);
      }
      $(".author-heading .content-container .author-description").toggleClass(
        "show"
      );
      $(".toggle-author-desc").toggleClass("show");

      return null;
    }
    return null;
  });
});
